export const GOLD_BAR_IN_CART_ERROR_MESSAGE = 'Limit 1 per customer per year'
export const GOLD_BAR_SUBCLASS = 1499
